import { render } from "./QuoteView.vue?vue&type=template&id=0c296a30&scoped=true"
import script from "./QuoteView.vue?vue&type=script&lang=js"
export * from "./QuoteView.vue?vue&type=script&lang=js"

import "./QuoteView.vue?vue&type=style&index=0&id=0c296a30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c296a30"]])

export default __exports__